import '.d{display:flex;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.d1{border-radius:0.75rem;}.ssr-plugin'
import '.aa{min-width:0px;}.ssr-plugin'
import '.d2{font-size:1.125rem;}.ssr-plugin'
import '.me{min-height:1.75rem;}.ssr-plugin'
import '.ah{flex-grow:1;}.ssr-plugin'
import '.p{padding:0px;}.ssr-plugin'
import '.c4{border:none;}.ssr-plugin'
import '.d4{outline:none;}.ssr-plugin'
import '.d5{background:transparent;}.ssr-plugin'
import '.mf{field-sizing:content;}.ssr-plugin'
import '.mb{font-family:inherit;}.ssr-plugin'
import '.fx{line-height:1.75rem;}.ssr-plugin'
import '.l{width:100%;}.ssr-plugin'
import '.b6{overflow-wrap:break-word;}.ssr-plugin'
import '.b7{word-break:break-word;}.ssr-plugin'
import '.mg{hyphens:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { forwardRef, KeyboardEventHandler, FocusEventHandler } from 'react'
import { InputField } from '../InputField'

export type TextAreaProps = {
  value: string
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void
  placeholder?: string
  label?: string
  labelStyle?: Style
  tooltipText?: string
  required?: boolean
  disabled?: boolean
  errorMessage?: string
  style?: Style
  containerStyle?: Style
  maxLength?: number
  autoResize?: boolean
  onFocus?: FocusEventHandler<HTMLTextAreaElement>
  onBlur?: FocusEventHandler<HTMLTextAreaElement>
  onKeyDown?: KeyboardEventHandler<HTMLTextAreaElement>
}

export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
  (
    {
      value,
      onChange,
      placeholder,
      label,
      labelStyle,
      tooltipText,
      required,
      disabled,
      errorMessage,
      style,
      containerStyle,
      maxLength,
      autoResize,
      onFocus,
      onBlur,
      onKeyDown,
    }: TextAreaProps,
    ref,
  ) => {
    const errorStateOn = !disabled && !!errorMessage

    return (
      <InputField
        label={label}
        labelStyle={labelStyle}
        tooltipText={tooltipText}
        required={required}
        errorMessage={errorStateOn ? errorMessage : undefined}
        style={style}
      >
        <styled.div className="d t d1 aa"
          style={{
            ...containerStyle,
          }}
        >
          <styled.textarea className="d2 me ah p c4 d4 d5 mf mb fx l aa b6 b7 mg"
            ref={ref}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            onFocus={onFocus}
            onBlur={onBlur}
            onKeyDown={onKeyDown}
            disabled={disabled}
            maxLength={maxLength}
            style={{
              resize: autoResize ? 'vertical' : 'none',
              '&::placeholder': {
                color: errorStateOn ? 'var(--status-error)' : 'var(--gray-300)',
                userSelect: 'none',
              },
              '&:disabled': {
                cursor: 'not-allowed',
              },
              ...(style as Record<string, unknown>),
            }}
          />
        </styled.div>
      </InputField>
    )
  },
)

TextArea.displayName = 'TextArea'
